import { render, staticRenderFns } from "./renewForm.vue?vue&type=template&id=122c3985"
import script from "./renewForm.vue?vue&type=script&lang=js"
export * from "./renewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports